import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import {
  addUserRequest,
  addUserRequestSuccess,
  addUserRequestError,
} from "../../../slices/teams/members/AddUserSlice";

export const AddUsers = (userData) => async (dispatch) => {
  try {
    dispatch(addUserRequest());
    const url = endpoints.addUser;
    const response = await axiosInstance.post(url, userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    dispatch(addUserRequestSuccess(response.data));
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Failed to add user";

    const _error = {
      data: errorMessage,
      status: error?.response?.status,
    };

    dispatch(addUserRequestError(_error));
    throw _error;
  }
};
